import React, { useEffect, useState } from 'react';
import usePwaDisplayMode from '../hooks/usePwaDisplayMode';
import '../css/top-brand-bar.css';

export const BRAND_BAR_HEIGHT = 36;

const TopBrandBar = () => {
  const { isPwaExperience } = usePwaDisplayMode();

  useEffect(() => {
    // Only set CSS variable when in PWA mode
    if (isPwaExperience) {
      document.documentElement.style.setProperty('--brand-banner-height', `${BRAND_BAR_HEIGHT}px`);
    }
    
    return () => {
      if (isPwaExperience) {
        document.documentElement.style.removeProperty('--brand-banner-height');
      }
    };
  }, [isPwaExperience]);

  // Don't render anything on desktop
  if (!isPwaExperience) {
    return null;
  }

  return (
    <div className="top-brand-bar" role="banner">
      <div className="top-brand-inner">
        <img
          src="/img/logo.png"
          alt="New Atlantic logo"
          className="top-brand-logo"
          loading="lazy"
        />
        <div className="top-brand-text">
          <span className="top-brand-company">PHẦN MỀM QUẢN LÝ</span>
        </div>
      </div>
    </div>
  );
};

export default TopBrandBar;
